import React from 'react';
import Icon from '../Icon/Icon';

/**
 * Show Type Card Component
 * Used for displaying show categories (Weddings, Corporate, Festivals, etc.)
 * 
 * @param {string} icon - Material icon name
 * @param {string} title - Show type title
 * @param {string} description - Show type description
 * @param {string} accentColor - 'pink' | 'primary' | 'cyan' | 'gold'
 * @param {function} onClick - Click handler
 */
const ShowTypeCard = ({
  icon,
  title,
  description,
  accentColor = 'primary',
  onClick,
  className = '',
}) => {
  const colorStyles = {
    pink: {
      hover: 'hover:ring-neon-pink/50 hover:shadow-glow-neon',
      icon: 'group-hover:bg-neon-pink group-hover:text-white',
      text: 'group-hover:text-neon-pink',
      chevron: 'group-hover:text-neon-pink',
      glow: 'bg-neon-pink/10',
    },
    primary: {
      hover: 'hover:ring-primary/50 hover:shadow-glow-primary',
      icon: 'group-hover:bg-primary group-hover:text-white',
      text: 'group-hover:text-primary',
      chevron: 'group-hover:text-primary',
      glow: 'bg-primary/10',
    },
    cyan: {
      hover: 'hover:ring-cyan-400/50 hover:shadow-glow-cyan',
      icon: 'group-hover:bg-cyan-500 group-hover:text-white',
      text: 'group-hover:text-cyan-400',
      chevron: 'group-hover:text-cyan-400',
      glow: 'bg-cyan-400/10',
    },
    gold: {
      hover: 'hover:ring-gold/50',
      icon: 'group-hover:bg-gold group-hover:text-black',
      text: 'group-hover:text-gold',
      chevron: 'group-hover:text-gold',
      glow: 'bg-gold/10',
    },
  };

  const styles = colorStyles[accentColor];

  return (
    <div
      onClick={onClick}
      className={`
        group relative flex items-center gap-3 rounded-xl bg-card-dark p-3 
        ring-1 ring-white/5 transition-all duration-300 
        ${styles.hover} hover:bg-[#202938] cursor-pointer overflow-hidden
        ${className}
      `}
    >
      {/* Glow Effect */}
      <div className={`absolute right-0 top-0 -mt-4 -mr-4 h-20 w-20 rounded-full ${styles.glow} blur-2xl transition-opacity opacity-0 group-hover:opacity-100`} />
      
      {/* Icon */}
      <div className={`relative z-10 flex size-10 shrink-0 items-center justify-center rounded-lg bg-[#223249] text-white transition-colors ${styles.icon}`}>
        <Icon name={icon} size="md" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center flex-1">
        <p className={`text-white text-sm font-semibold leading-tight transition-colors ${styles.text}`}>
          {title}
        </p>
        <p className="text-[#90a9cb] text-xs font-normal leading-normal line-clamp-2 mt-0.5">
          {description}
        </p>
      </div>
      
      {/* Chevron */}
      <div className={`ml-auto text-[#223249] transition-colors ${styles.chevron}`}>
        <Icon name="chevron_right" size="sm" />
      </div>
    </div>
  );
};

export default ShowTypeCard;
